// extracted by mini-css-extract-plugin
module.exports = {"info":"AreaPageFindCar_info__vBuk1"};